import { useLang } from "../../lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee.items");
  const row = [...items, ...items, ...items];
  return (
    <div className="bg-beige border-y border-taupe/20 py-6 overflow-hidden" data-testid="editorial-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-2xl lg:text-3xl text-espresso/80 italic px-10">{item}</span>
                <span className="text-gold text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
